module.exports = __webpack_public_path__ + "img/templates.d620bb61.svg";